{
  "ACTIVITEITEN": {
    "ACTIEPUNTEN": {
      "BUTTON": {
        "SLUITEN": "Abbrechen"
      }
    }
  },
  "ALGEMEEN": {
    "ANNULEREN": "Stornieren",
    "FOUT": {
      "TITEL": "Fehler"
    },
    "GEEN_VERTALING": "Fehlende Übersetzung: {{tag}}",
    "GELUKT": "Erfolg",
    "KIES_TAAL": "Kies je taal/Choose your language/Wählen Sie Ihre Sprache",
    "OPSLAAN": "Speichern",
    "TAALKEUZE_VERPLICHT": "Sie müssen eine Wahl treffen",
    "TAAL_GEWIJZIGD": "Die Sprache wurde erfolgreich geändert",
    "TAAL_NIET_GEWIJZIGD": "Die Sprache wird nicht geändert",
    "WAARSCHUWING": "Achtung"
  },
  "Algemeen": {
    "LicentieActief": "Lizenz aktiv",
    "LicentieVerlopen": "Lizenz abgelaufen"
  },
  "CONTACTGEGEVENS": {
    "TITEL": "Kontaktdetails"
  },
  "DASHBOARD": {
    "NIEUWS": {
      "TITEL": "Nachrichtenberichte"
    },
    "OBJECTEN": {
      "KENBRI_ADVIES": "Kenbri empfiehlt, bei Abweichungen innerhalb des folgenden Zeitrahmens Maßnahmen zu ergreifen",
      "TITEL": "Objekte",
      "TOTAAL_AANTAL": "Anzahl der Objekte"
    }
  },
  "DOCUMENTEN": {
    "ALGEMEEN": {
      "GRID": {
        "AANGEMAAKTOP": "Erstellt am",
        "DOCUMENTSOORT": "Dokumenttyp",
        "GROOTTE": "Größe",
        "LAATSTGEWIJZIGDOP": "Zuletzt geändert am",
        "NAAM": "Name",
        "OPMERKINGEN": "Kommentare"
      }
    },
    "OBJECT": {
      "GRID": {
        "OBJECT": "Objekte",
        "OPMERKINGEN": "Kommentare"
      },
      "TITEL": "Unterlagen"
    },
    "RAPPORTAGE": {
      "TITEL": "Berichterstattung"
    },
    "TITEL": "Unterlagen",
    "UPLOAD_DOCUMENT": "Dokument hochladen"
  },
  "GEBRUIKERMENU": {
    "LOGO_UPLOADEN": "Logo hochladen",
    "TAAL_WIJZIGEN": "Sprache ändern",
    "UITLOGGEN": "Ausloggen",
    "WACHTWOORD_WIJZIGEN": "Kennwort ändern"
  },
  "INFO": {
    "GEPLANDE_WIJZIGINGEN": {
      "TITEL": "Geplante Änderungen für",
      "VERSIE": "Version"
    },
    "NIEUWS": {
      "GEEN_NIEUWS": "Im Moment liegen keine Nachrichten vor."
    },
    "VERSIE_OVERZICHT": {
      "VERSIE": "Version"
    }
  },
  "LOGIN": {
    "MELDING": {
      "ONDERHOUD": "Aufgrund von Wartungsarbeiten ist TotalCare vorübergehend nicht verfügbar."
    }
  },
  "MENU": {
    "ACTIVITEITEN": {
      "ACTIEPUNTEN": "Aktionspunkte",
      "KENBRI_ACTIVITEITEN": "Eigene Aktivitäten",
      "NOTULEN": "Sitzungsprotokoll",
      "PERIODE_OVERZICHT": "Periodenübersicht",
      "TITEL": "Aktivitäten"
    },
    "BEHEER": {
      "GEBRUIKERS": "Benutzer",
      "PRESENTER": {
        "TITEL": "Presenter"
      },
      "TITEL": "Management"
    },
    "CONFIGURATIE": {
      "AUTORISATIE": "Autorisierung",
      "ROLLEN": "Rollen",
      "TITEL": "Konfiguration"
    },
    "CONTACTGEGEVENS": {
      "TITEL": "Kontaktdetails"
    },
    "DASHBOARD": "Dashboard",
    "DOCUMENTEN": {
      "ALGEMEEN": "Allgemein",
      "OBJECTEN": "Objekte",
      "RAPPORTAGE": "Berichterstattung",
      "TITEL": "Unterlagen"
    },
    "HELP": {
      "FAQ": "FAQ",
      "HANDLEIDINGEN": "Benutzerhandbücher",
      "TITEL": "Helfen"
    },
    "INFO": {
      "GEPLANDE_WIJZIGINGEN": "Bevorstehende Änderungen",
      "NIEUWS": "Nachrichtenberichte",
      "TITEL": "Info",
      "UW_LICENTIE": "Ihre Lizenz",
      "VERSIE_OVERZICHT": "Versionsübersicht"
    },
    "OBJECTEN": {
      "AANGEVRAAGD": "Angefordert",
      "EXTERNE_KOPPELINGEN": "Externe links",
      "OVERZICHT": "Überblick",
      "TITEL": "Objekte",
      "VERVALLEN": "Abgelaufen"
    },
    "PLANNING": {
      "TITEL": "Planung"
    },
    "SEVESO": {
      "ACTIEPUNTEN": "Aktionspunkte",
      "DASHBOARD": "Dashboard",
      "DOCUMENTEN": "Unterlagen",
      "DOSSIERS": "Dossiers",
      "MODEL": "Model",
      "TITEL": "SEVESO",
      "TRENDS": {
        "LEVENSDUUR": "Lebensdauer",
        "NUMERIEKE_DATA": "Numerische Daten",
        "TITEL": "Trendanalysen",
        "WERKCODES": "Arbeitscodes"
      }
    },
    "WERKCODE_ANALYSE": {
      "TITEL": "Arbeitscodeanalyse"
    }
  },
  "OBJECTEN": {
    "EXTERNE_LINKS": {
      "GRID": {
        "DETAIL": {
          "OBJECT": "Objekte"
        }
      }
    }
  },
  "PLANNING": {
    "TITEL": "Planung"
  },
  "WACHTWOORD_WIJZIGEN": {
    "TITEL": "Kennwort ändern"
  }
}